export enum MessageType {
    ARTICLE = 'article',
    CARD_LIST_EMPTY = 'card-list-empty',
    COMING_SOON = 'coming-soon',
    COMING_SOON_HIDDEN = 'coming-soon-hidden',
    EMPTY = 'empty',
    EMPTY_BOX = 'empty-box',
    ERROR = 'error',
    ERROR_HAND = 'error-hand',
    ERROR_PENDING = 'error-pending',
    ERROR_SERVER = 'error-server',
    ERROR_WIDTH_ICON = 'error-width-icon',
    INFO = 'info',
    LABEL = 'label',
    SUCCESS = 'success',
    SUCCESS_WITH_CHECKED = 'success-with-checked',
    TIPS = 'tips',
    TRANSACTION_EMPTY = 'transaction-empty',
    TRANSACTION_NO_MORE = 'transaction-no-more',
    WARNING = 'warning',
}

export enum TextAlign {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export const UNRESPONSIVE_TYPES_LIST: MessageType[] = [
    MessageType.COMING_SOON,
    MessageType.COMING_SOON_HIDDEN,
    MessageType.ERROR_SERVER,
    MessageType.ERROR_PENDING,
    MessageType.EMPTY,
];
